<template>
  <div class="container">
    <!-- <img class="containerimg" src="../../assets/images/activity/202104/a5.png" /> -->
    <img class="containerimg1" src="../../../assets/images/activity/202104/aa1.png" />
    <div class="containerimg">
      <img class="containerimg2" src="../../../assets/images/activity/202104/aa2.png" />
      <div class="containerimgt">
        <div @click="lingquan()">{{btn}}</div>
      </div>
    </div>

    <div class="containerimgdisan">
      <img class="containerimg3" src="../../../assets/images/activity/202104/aa3.png" />
      <div class="disan">
        <div @click="toshareapp()" class="disanbtn">发送给朋友</div>
      </div>
    </div>
    <div class="containerimgdisi">
      <img class="containerimg4" src="../../../assets/images/activity/202104/aa4.png" />
      <div class="containerimgdisi_txt">
        <div class="containerimgdisi_txtbtn" @click="tindex()">返回斐燃生活</div>
        <div @click="Callcustomerservice()" class="containerimgdisi_txtlab"></div>
      </div>
    </div>

    <div class="bb_coupon_list_mask" @click="cancelcouponshare()" v-show="couponmask">
      <img src="../../../assets/images/base/zhixiang.png" />
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        btn:'活动已结束',//'一键抢券',
        couponmask:false
      }
    },
    created() {
      window.scrollTo(0,0)
      this.isViper()
      this.sharefriend()
    },
    mounted() { },
    methods: {
      Callcustomerservice() {
        window.location.href = "tel:400-630-5888"
      },
      toshareapp(){
        this.couponmask=true
      },
      cancelcouponshare(){
        this.couponmask=false
      },
      sharefriend(){
        let that = this;
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // const baseurl = encodeURI((window.location.href).split('.cn')[0])+'.cn'//"http://test.official.unionfit.cn"; //本地测试地址
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '【超值】斐燃生活限时抢“神券”', // 分享标题
            desc: '斐燃会员五折专享全国五星级酒店游泳、健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('/acfour')[0])+'/acfour', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateAppMessageShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateAppMessageShareData')
            }
          });
          wx.updateTimelineShareData({
            title: '【超值】斐燃生活限时抢“神券”', // 分享标题
            link: encodeURI((window.location.href).split('/acfour')[0])+'/acfour', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateTimelineShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateTimelineShareData')
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '【超值】斐燃生活限时抢“神券”', // 分享标题
            desc: '斐燃会员五折专享全国五星级酒店游泳、健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('/acfour')[0])+'/acfour', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareAppMessage')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareAppMessage')
            }
          });
          wx.onMenuShareTimeline({
            title: '【超值】斐燃生活限时抢神券', // 分享标题
            link: encodeURI((window.location.href).split('/acfour')[0])+'/acfour', // 分享链接
            imgUrl: 'http://img.unionfit.cn/qingmingjie_share.png', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareTimeline')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareTimeline')
            }
          });
        }
      },
      isViper(){
        var $this = this
        console.log($this.$store.state.array_mycard)
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.flUserCardsList
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          if (result.code==0) {
            console.log(result)

          } else {

          }
        }).catch((error) => {
          // console.warn(error)
        })
      },
      tindex(){
        window.scrollTo(0,0)
        // return
        this.$router.push({
          name:'guidapplet'
        })
      },
      lingquan(){
        this.$router.push({
          name:'guidapplet'
        })
        return
        var $this = this
        if($this.btn=='成为斐燃会员'){
          $this.$router.push({
            name:'guidapplet'
          })
          return
        }
        if($this.btn=='预约酒店游泳健身'){
          $this.$router.push({
            name:'guidapplet'
          })
          return
        }


        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.flUserInAction
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          localStorage.setItem('ac_202104011','yes')
          if (result.code==0) {
            console.log(result)
            // localStorage.setItem('ac_20210401','yes')
            $this.$toast('您已抢到优惠券')
            $this.btn='成为斐燃会员'
          } else if(result.code==1001){
            $this.$toast('您已经是斐燃会员了')
            $this.btn='预约酒店游泳健身'
          }else if(result.code==1002){
            $this.$toast('您已经抢过优惠券了')
            $this.btn='成为斐燃会员'
          }else{
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          localStorage.setItem('ac_202104011','yes')
          // console.warn(error)
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .containerimg1{
    width: 100%;
  }
  .containerimg{
    position: relative;
    .containerimgt{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 112*@vm_base 40*@vm_base 112*@vm_base;
      // border: 1*@vm_base solid red;
      div{
        width: 100%;
        background: linear-gradient(136deg, #DB9C6E 0%, #C36927 100%);
        box-shadow: 0px 10px 20px 0px #E3B393, 1px 2px 3px 0px #FFF0B7, 0px 4px 9px 0px rgba(255, 246, 222, 0.5);
        border-radius: 12*@vm_base;
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        padding: 18*@vm_base;
      }
    }
  }

  .containerimg2{
    width: 100%;
  }
  .containerimg3{
    width: 100%;
  }
  .containerimgdisan{
    position: relative;
    .disan{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 112*@vm_base 30*@vm_base 120*@vm_base;
      .disanbtn{
        width: 100%;
        background: linear-gradient(136deg, #DB9C6E 0%, #C36927 100%);
        box-shadow: 0px 10px 20px 0px #E3B393, 1px 2px 3px 0px #FFF0B7, 0px 4px 9px 0px rgba(255, 246, 222, 0.5);
        border-radius: 12*@vm_base;
        text-align: center;
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        padding: 18*@vm_base;
      }
    }
  }
  .containerimg4{
    width: 100%;
  }

  .containerimgdisi{
    position: relative;
    .containerimgdisi_txt{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 112*@vm_base 184*@vm_base 112*@vm_base;
      .containerimgdisi_txtbtn{
        width: 100%;
        background: linear-gradient(136deg, #A66F46 0%, #915123 100%);
        border-radius: 12*@vm_base;
        text-align: center;
        padding: 18*@vm_base;
        font-size: 28*@vm_base;
        font-weight: 500;
        color: #F9E4DA;
      }
      .containerimgdisi_txtlab{
        width: 100%;
        height: 20*@vm_base;
        margin-top: 50*@vm_base;
      }
    }
  }
  .bb_coupon_list_mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background:rgba(0,0,0,0.6);
    z-index: 100;
    img{
      width: 361*@vm_base;
      float: right;
      margin-right: 60*@vm_base;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/acfour/acfour.vue